/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brief_Gold_Hare_RestInputs */

const en_brief_gold_hare_rest = /** @type {(inputs: Brief_Gold_Hare_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest`)
};

const de_brief_gold_hare_rest = /** @type {(inputs: Brief_Gold_Hare_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuell`)
};

/**
* | output |
* | --- |
* | "Latest" |
*
* @param {Brief_Gold_Hare_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const brief_gold_hare_rest = /** @type {((inputs?: Brief_Gold_Hare_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brief_Gold_Hare_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_brief_gold_hare_rest(inputs)
	return de_brief_gold_hare_rest(inputs)
});